$(document).ready(function(){

//   const urlParams_test = new URLSearchParams(window.location.search);
//   const editorActive_test = urlParams_test.get('oseid');
//   if (editorActive_test!=null) {
//   		$(".view_sample").show();
//   }
  
  var options_qkview = {
     slidesToShow: 5,
      slidesToScroll: 5,
      centerMode: false,
      centerPadding: "10px",
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 5,
          },
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 2,
          },
        },
      ]
    }
    //$(".qkv_thumbs_picture").slick(options);
        
  
  /****Quick View****/
  var product='';
  let main_obj_variant = '';
  let variant_id='';
  var product_id = '';
  var product_url='';
  var inc=0;
  
  function remove_query_string_value(s){
    var n = s.indexOf('?');
    s = s.substring(0, n != -1 ? n : s.length);
    return s;
  }
        
  $('body').on("click",".quickview",function(){

      
  //$(".quickview").click(function(){
    
    $(".qkv_notification").hide(); 
    $(".qkv_notification").removeClass('success');
    $(".qkv_notification").removeClass('danger'); 
    $(".qkv_notification").html('')
  	
    var $this = $(this);
    product_id = $this.attr("data-productid");
    variant_id = $this.attr("data-id");
    product_url = remove_query_string_value($this.attr("data-url"));
        
       
    
    
    
    // Retrieve the product data using Shopify's frontend API endpoint
    fetch(product_url + '.js').then(function(response){ return response.json() }).then( 
      function(product){
        
        $(".qkv_thumbs_picture").html('');
        if(inc > 0){
        //alert("run")
        	$('.qkv_thumbs_picture').slick('unslick');
        }
        
         $(".qkv_product_title").text(product.title);
        var description  = product.description;
         $(".qkv_product_description").html( description.substring(0, 300)+"..."); 
        
        $(".qkv_product_url_container").html('<a id="sca-qv-detail" href="'+product.url+'">View full product details </a>')
         
        
         /***Gallery Image set **/
        var media = product.media;
        $(".qkv_thumbs_picture").html('');
        for(var i = 0; i<media.length; i++){
          if(i == 0){
          	$(".qkv_main_picture").html('<img src="'+media[i].src+'" class="main_preview_picture" alt="'+media[i].alt+'" id="qk_img_main'+media[i].id+'">');
            $(".qkv_thumbs_picture").append('<img src="'+media[i].src+'" class="thumb_preview_picture" alt="'+media[i].alt+'" id="qk_img_'+media[i].id+'">');
          }else{
          	$(".qkv_thumbs_picture").append('<img src="'+media[i].src+'" class="thumb_preview_picture" alt="'+media[i].alt+'" id="qk_img_'+media[i].id+'">');
          }
        }
                  
                  
        
         /**Swatches Create**/
        var options =  product.options;
        if (typeof options !== 'undefined' && options.length > 0) {
        	var options_fields = options[0];
          	var options_fields_value = options[1];
          	
          /****Type get***/
          	$(".qkv_variant_type_name").text(options_fields.name);
          	var list_type_value='';
            for(var i=0;i<options_fields.values.length; i++){
				list_type_value+="<li class='field_name product_type_"+options_fields.values[i]+"' data-name='"+options_fields.values[i]+"' data-productid='"+product.id+"'>" +options_fields.values[i]+ "</li>";
            }
          	$(".qkv_variant_type_name_value_list").html(list_type_value);
          
          /****Value get***/
          	$(".qkv_variant_value_name").text(options_fields_value.name);

        }
        
        
        
        
        main_obj_variant = product.variants;
        
        /****Field Set variant id*****/
        variant_set_field_varid(main_obj_variant)
        
        /****Default set*****/
        variant_selection(main_obj_variant,variant_id);
        

		
		$('.qkv_thumbs_picture').slick(options_qkview);
        
        $("#quickviewmodal").show();
		inc = inc + 1;
		mlvedaload();
		
      }
    )
    
  });
  
  $(".close_quickviewmodal").click(function(){
  
    $("#quickviewmodal").hide();
  });

  function variant_set_field_varid(variants){
    var list_type_value_value='';
    for (var i = 0; i < variants.length; i++) {
    	
      
      list_type_value_value+="<li class='field_value product_type_value_"+str_replace_cst(variants[i].option2)+"  type_"+variants[i].option1+" ' data-name='"+variants[i].option2+"' data-variant='"+variants[i].id+"' style='display:none;'> <span class='view_popo'>"+variants[i].option2+"</span> <img class='qkv_thumb_color_name' src='"+variants[i].featured_image.src+"' alt='"+variants[i].option2+"' data-title='"+variants[i].option2+"'></li>";
        
        
    }
    $(".qkv_variant_value_name_value_list").html(list_type_value_value);
    
  }
  function variant_selection(variants, current_var_id){
    
    for (var i = 0; i < variants.length; i++) {
      if(variants[i].id == current_var_id){
        
        /***Selections***/
        var price =  parseFloat(variants[i].price)/ 100;
        //$(".qkv_product_price").html( "&#163;"+  price);
        
       
        
        $(".qkv_product_price").html("<span class=money>&#163;"+price+"</span>");
        
        /***Select Current Picture***/
        $(".main_preview_picture").removeClass('active');
        $(".thumb_preview_picture").removeClass('active');
        $("#qk_img_"+variants[i].featured_media.id).addClass('active');
        $(".qkv_main_picture").html('<img src="'+variants[i].featured_image.src+'" class="main_preview_picture" alt="'+variants[i].featured_image.alt+'" id="qk_img_main'+variants[i].featured_image.id+'">');
        
        
        $(".field_name").removeClass('active');
        
        $(".product_type_"+variants[i].option1).addClass("active");
        
        
        
        
        $(".field_value").removeClass('active')
        $(".product_type_value_"+variants[i].option2).addClass("active");
        
        /***Color/Type show on label*****/
        /*
        $(".qkv_type").text( " PER: "+ variants[i].option1 );
        $(".qkv_color").text( ": "+ variants[i].option2 );*/
        
        $(".field_value").hide();
        $(".type_"+variants[i].option1).show();
      }
        	
    }
  }
  
  $("body").on("click",".field_name",function(){
  		
    var $this = $(this);
    $(".field_name").removeClass('active');
    $this.addClass('active');
    $(".field_value").hide();
    $(".type_"+$this.attr('data-name')).show();
    
    var current_field = $(".type_"+$this.attr('data-name')+".active");
    variant_id = current_field.attr('data-variant');
    /****Default set*****/
     variant_selection(main_obj_variant,variant_id);
  });
  
  $("body").on("click",".field_value",function(){
  		
    var $this = $(this);
    $(".field_value").removeClass('active');
    $this.addClass('active');
    
    variant_id = $this.attr('data-variant');
    /****Default set*****/
     variant_selection(main_obj_variant,variant_id);
  });
  
  $(".qkv_button_cart").click(function(){
    var $this = $(this);
    var qtyval = $(".qkv_input_qty").val();

    if(qtyval=='' || qtyval == 0){
      alert("QTY value required");
      return false;
    }
    
    $this.addClass('cart-loading');
    		
    data = {
            id: variant_id,
            quantity: qtyval
     },
    $(".qkv_notification").hide(); 
    $(".qkv_notification").removeClass('success');
    $(".qkv_notification").removeClass('danger'); 
     $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: data,
          dataType: "json",
          success: function(response) {
            setCart();
            
            setTimeout(function(){ 
              $(".qkv_notification").addClass('success')
              var total_cart = $("#CartCount").attr('data-count');
              var total_subtotal = $("#CartCount").attr('data-subtotal');
              $("#popup_cart_subtotal").text(total_subtotal);
              
              $(".qkv_notification").show(); 
              $(".qkv_notification").addClass('success');
              $(".qkv_notification").html("<strong>Sucess </strong> Product has been added to cart successfully!"); 
              /***End Popup show ***/
              }, 500);
            
            $this.removeClass('cart-loading');
            $this.removeClass('add_to_cart_ajax_cust_info');
            $(".qkv_input_qty").val('0');
            
          },error(response, status, error){
            $this.removeClass('cart-loading');
            $(".qkv_notification").show(); 
            if(response.responseJSON.status == "422"){
              
              $(".qkv_notification").addClass('danger');
              $(".qkv_notification").html("<strong>Error </strong> Can't add more same product in your cart - " +response.responseJSON.description); 
              alert("Can't add more same product in your cart - "+response.responseJSON.description);
            }else{
              alert("Sorry, Something went wrong, Please try after some time.");
              $(".qkv_notification").html("<strong>Error </strong> Sorry, Something went wrong, Please try after some time."); 
            }
            
          
          }
        
        });    	
  
  });
  
  $("body").on("click",".thumb_preview_picture",function(){
    var $this = $(this);
    $(".thumb_preview_picture").removeClass('active');
    $this.addClass('active');
    $(".main_preview_picture").attr("src",$this.attr('src'))
    
  });
  
  
  
   function setCart(){
    var carttext  = 0;
    $.getJSON('/cart.js', function (cart, textStatus) {
      carttext=cart.item_count;
      $("#CartCount").children('span').text(carttext);
      $("#CartCount").attr('data-count',carttext);
      var price_total = parseFloat(cart.total_price)/100;
       $("#CartCount").attr('data-subtotal',price_total);
    });
    return carttext;
  }

function str_replace_cst(text){

	return text.replace(" ", "");
}
  

});